import { Typography } from "@mui/material";
import EmptyLoanStyle from "../../../../components/icons/EmptyLoanStyle";

export default function EmptyStyleGuarantor() {
    return (
        <div className="flex flex-col items-center justify-center" style={{ textAlign: 'center' }}>
            <EmptyLoanStyle className="mt-10 text-center text-[var(--primary-text-color)]" />
            <Typography className=" !mt-12 text-[var(--primary-text-color)]">
                تاکنون  <span className="text-[#BBA57A]">  ضامن</span> نشده اید.

            </Typography>
        </div>
    )
}
